import { OrganisationsService } from '../../../services';
import { RoleService } from '../../../services';
import { UserService } from '../../../services';
import { IUser } from './../../../interfaces/user.d';
import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Message, SelectItem, TreeNode } from 'primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'user-details',
  templateUrl: 'user-details.component.html',
})
export class UserDetailsComponent implements OnInit {
  public userForm: UntypedFormGroup;

  public roles: SelectItem[];
  public organisations: SelectItem[];
  public departments: SelectItem[];
  public regions: SelectItem[];
  public teams: SelectItem[];
  public depots: SelectItem[];

  public orgType: number;

  public selectedOrg: any;
  public selectedDepartmentOrRegion: any;
  public selectedTeamOrDepot: any;

  constructor(
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private orgService: OrganisationsService,
    private roleService: RoleService,
    private location: Location,
  ) {}

  ngOnInit() {
    this.orgType = this.route.snapshot.params['orgType'];

    this.userForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([Validators.required, Validators.email, Validators.maxLength(254)]),
      ],
      phoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(20)])],
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      lastName: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      userRoles: [[], Validators.required],
      organisationId: 0,
      userOrganisationLevel: {
        id: [0],
        userId: [''],
        organisationId: [null],
        supplierRegionId: [null],
        supplierDepotId: [null],
        customerDepartmentId: [null],
        customerTeamId: [null],
      },
    });

    this.userService.get(this.route.snapshot.params['id']).then((data) => {
      console.log(data);
      this.userForm = this.formBuilder.group({
        id: [data.id],
        email: [
          data.email,
          Validators.compose([Validators.required, Validators.email, Validators.maxLength(254)]),
        ],
        phoneNumber: [
          data.phoneNumber,
          Validators.compose([Validators.required, Validators.maxLength(20)]),
        ],
        firstName: [
          data.firstName,
          Validators.compose([Validators.required, Validators.maxLength(100)]),
        ],
        lastName: [
          data.lastName,
          Validators.compose([Validators.required, Validators.maxLength(100)]),
        ],
        userRoles: [data.roles, Validators.required],

        userOrganisationLevel: this.formBuilder.group({
          id: [data.userOrganisationLevel.id],
          userId: [data.userOrganisationLevel.userId],
          organisationId: [data.userOrganisationLevel.organisationId],
          supplierRegionId: [data.userOrganisationLevel.supplierRegionId],
          supplierDepotId: [data.userOrganisationLevel.supplierDepotId],
          customerDepartmentId: [data.userOrganisationLevel.customerDepartmentId],
          customerTeamId: [data.userOrganisationLevel.customerTeamId],
        }),
      });

      this.userService.getCurrentUserOrg().then((data) => {
        this.selectedOrg = data;

        this.loadRoles();

        this.loadDepartments();
        this.loadTeams();

        this.loadRegions();
        this.loadDepots();
      });
    });
  }

  loadDepartments() {
    this.departments = [];
    this.departments.push({ label: 'Select Department...', value: '' });
    this.selectedOrg.departments.forEach((d) => {
      this.departments.push({ label: d.name, value: d.id });
    });
  }

  loadRegions() {
    this.regions = [];
    this.regions.push({ label: 'Select Region...', value: '' });
    this.selectedOrg.regions.forEach((d) => {
      this.regions.push({ label: d.name, value: d.id });
    });
  }

  loadTeams() {
    if (this.userForm.value.userOrganisationLevel.customerDepartmentId != null) {
      this.orgService
        .getDepartment(this.userForm.value.userOrganisationLevel.customerDepartmentId)
        .then((data) => {
          this.teams = [];
          this.teams.push({ label: 'Select Team...', value: '' });
          data.teams.forEach((t) => {
            this.teams.push({ label: t.name, value: t.id });
          });
        });
    }
  }

  loadDepots() {
    if (this.userForm.value.userOrganisationLevel.supplierRegionId != null) {
      this.orgService
        .getRegion(this.userForm.value.userOrganisationLevel.supplierRegionId)
        .then((data) => {
          this.depots = [];
          this.depots.push({ label: 'Select Depot...', value: '' });
          data.depots.forEach((d) => {
            this.depots.push({ label: d.name, value: d.id });
          });
        });
    }
  }

  loadRoles() {
    this.roleService.getRolesByOrg(this.selectedOrg.id, 1).then((data) => {
      this.roles = [];
      data.forEach((r) => {
        this.roles.push({ label: r.description, value: r });
      });
    });
  }

  orgChange($event) {
    this.orgService.getOrg($event.value).then((data) => {
      this.selectedOrg = data;

      this.loadRoles();
      this.loadDepartments();
      this.loadRegions();
    });
  }

  departmentChange($event) {
    this.loadTeams();
  }

  regionChange($event) {
    this.loadDepots();
  }

  save(formValues) {
    var user = <IUser>formValues;
    user.organisationId = this.selectedOrg.id;

    this.userService.save(user).then((data) => {
      alert('send back');
      //this.backToUsersView();
    });
  }

  cancel() {
    this.backToUsersView();
  }

  backToUsersView() {
    this.location.back();
  }
}
